import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const AIToggle = ({
  visible,
  onToggle,
  l // translations
}) => {
  const handleClick = (e) => {
    // Send Google Analytics event
    if (typeof gtag === "function") {
      gtag("event", "ai_toggle", {
        "event_category": "engagement",
        "event_label": visible ? "close" : "open"
      });
    }
    
    // Call the original onToggle handler
    onToggle(e);
  };

  return (
    <Button
      className="right-section-btn"
      icon
      toggle
      active={visible}
      style={{
        marginLeft: '8px',
        paddingRight: '40px',
        background: 'transparent',
        color: '#ffffff',
        padding: '0.7em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={handleClick}
      title={l?.toggle_ai || 'Toggle AI Assistant'}
      aria-label="Toggle AI Assistant"
    >
      <Icon 
        name="wechat" 
        size="large"
        style={{
          margin: 0,
          fontSize: '1.5em'
        }}
      />
    </Button>
  );
};

export default React.memo(AIToggle);
